export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11097.f9a08616.jpg";